import React from 'react'
import TablaCargaBuquesView from './TablaCargaBuquesView'

function DetalleDeCarga () {
  return (
    <TablaCargaBuquesView />
  )
}

export default DetalleDeCarga
